import { API_URL, API_URL_V2, API_URL_V3, itemPerPage } from '../constants/index.js';
import {
    ACTIVITY,
    ACTIVITY_SUCCESS,
    ACTIVITY_ERROR,
    ACTIVITY_DETAIL,
    ACTIVITY_DETAIL_ERROR,
    ACTIVITY_DETAIL_SUCCESS,
    CALENDAR_ACTIVITY,
    CALENDAR_ACTIVITY_SUCCESS,
    CALENDAR_ACTIVITY_ERROR,
    ADD_ACTIVITY,
    ADD_ACTIVITY_SUCCESS,
    ADD_ACTIVITY_ERROR,
    UPDATE_ACTIVITY,
    UPDATE_ACTIVITY_SUCCESS,
    UPDATE_ACTIVITY_ERROR,
    DELETE_ACTIVITY,
    DELETE_ACTIVITY_ERROR,
    DELETE_ACTIVITY_SUCCESS,
    DELETE_ACTIVITIES,
    DELETE_ACTIVITIES_ERROR,
    DELETE_ACTIVITIES_SUCCESS,
    DELETE_ALL_ACTIVITIES_SUCCESS,
    ADD_DETAILS_IMAGE,
    ADD_DETAILS_IMAGE_ERROR,
    ADD_DETAILS_IMAGE_SUCCESS,
    DELETE_RECURRENCE_ACTIVITY_SUCCESS,
    DELETE_RECURRENCE_ACTIVITY_ERROR,
    DELETE_RECURRENCE_ACTIVITY,
    GET_ACTIVITIES_IMAGES,
    GET_ACTIVITIES_IMAGES_SUCCESS,
    GET_ACTIVITIES_IMAGES_ERROR,
    ACTIVITY_TAGS,
    ACTIVITY_TAGS_SUCCESS,
    ACTIVITY_TAGS_ERROR,
    ACTIVITY_FILTERS,
    ACTIVITY_FILTERS_ERROR,
    ACTIVITY_FILTERS_SUCCESS
} from '../constants/activitiesConstants';
import { sweetAlert } from '../components/Alert/sweetAlert.jsx';

import * as XLSX from 'xlsx';

//#region GET ACTIVITY
export function getActivity(data) {
    return {
        type: ACTIVITY,
        data
    }
};

export function getActivitySuccess(data, communityId, currentPage) {
    return {
        type: ACTIVITY_SUCCESS,
        data,
        communityId: communityId,
        currentPage: currentPage,
    }
};

export function getActivityError(data) {
    return {
        type: ACTIVITY_ERROR,
        data
    }
};

export function GetAllActivities(idCommunity, currentPage) {
    return dispatch => {
        dispatch(getActivity());

        return fetch(API_URL_V3 + `cms/activities/activities?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity,
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getActivitySuccess(res, idCommunity, currentPage));
            })
            .catch(error => {
                dispatch(getActivityError(error));
            })
    }
};

export function getActivitiesFilters(data) {
    return {
        type: ACTIVITY_FILTERS,
        data
    }
};

export function getActivityFiltersSuccess(data, communityId, currentPage) {
    return {
        type: ACTIVITY_FILTERS_SUCCESS,
        data,
        communityId: communityId,
        currentPage: currentPage,
    }
};

export function getActivityFiltersError(data) {
    return {
        type: ACTIVITY_FILTERS_ERROR,
        data
    }
};

const getHeaders = (filters, idCommunity, search, sort, direction) => {
    const headers = {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'CommunityId': idCommunity,
        'custom_sort': sort ? sort : 'date',
        'sort_dir': direction === true ? 1 : -1

    }

    if (filters.dateOptionSelected && filters.optionInFuture !== undefined) {

        headers.date_option = filters.dateOptionSelected
        headers.option_future = filters.optionInFuture;

    } else if (filters.dateChanged && !filters.dateOptionSelected) {
        headers.start_date = filters.startDate
        headers.end_date = filters.endDate
    }

    if (filters.categoriesSelected && filters.categoriesSelected.length > 0) {
        headers.categories = filters.categoriesSelected.join(',')
    }

    if (filters.registrationsActive) {
        headers.registrations = filters.registrationsActive;

        switch (filters.registrationsOption) {
            case 'Greater than':
                headers.lower_limit = filters.lowerLimit
                break;

            case 'Less than':
                headers.upper_limit = filters.upperLimit
                break;

            case 'Between':
                headers.lower_limit = filters.lowerLimit
                headers.upper_limit = filters.upperLimit
                break;

            default:
                break;
        }

    }

    if (filters.unlimitedSeats) {
        headers.unlimited_seats = filters.unlimitedSeats

    }

    if (filters.tagsSelected && filters.tagsSelected.length > 0) {
        headers.tags = filters.tagsSelected.join(',')

    }

    //Searching
    if (search && search !== '') {
        headers.search = search;
    }

    //Sorting
    if (sort === 'category') {
        headers.custom_sort = 'lowerCat'
    } else if (sort === 'title') {
        headers.custom_sort = 'lowerTitle'
    } else if (sort === 'registrations') {
        headers.custom_sort = 'attendeesLength'
    }


    return headers;

}

export function GetActivitiesFilters(idCommunity, currentPage, filters, search, sort, direction) {
    return dispatch => {
        dispatch(getActivitiesFilters());

        const headers = getHeaders(filters, idCommunity, search, sort, direction);

        return fetch(API_URL + `activities/filters?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: headers
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getActivityFiltersSuccess(res, idCommunity, currentPage));
            })
            .catch(error => {
                dispatch(getActivityFiltersError(error));
            })
    }
};


export function getCalendarActivity(data) {
    return {
        type: CALENDAR_ACTIVITY,
        data
    }
};

export function getCalendarActivitySuccess(data) {
    return {
        type: CALENDAR_ACTIVITY_SUCCESS,
        data
    }
};

export function getCalendarActivityError(data) {
    return {
        type: CALENDAR_ACTIVITY_ERROR,
        data
    }
};

export function GetCalendarActivities(idCommunity, startDate = undefined, endDate = undefined) {
    return dispatch => {
        let status = undefined

        let headers = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'CommunityId': idCommunity,
        }


        if (startDate && endDate) {
            headers = {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'CommunityId': idCommunity,
                'startdate': JSON.stringify(startDate),
                'enddate': JSON.stringify(endDate),
            }
        }
        dispatch(getCalendarActivity());

        return fetch(API_URL_V3 + 'activities/calendarActivities',
            {
                method: 'GET',
                headers: headers
            })
            .then(res => {
                status = res.status;

                return res.json();
            })
            .then(res => {
                let activities = [];
                if (status === 200 && res && Array.isArray(res)) {
                    activities = res;
                }

                dispatch(getCalendarActivitySuccess(activities));
                return activities;
            })
            .catch(error => {
                dispatch(getCalendarActivityError(error));

            })
    }
};

export function getActivityDetail(data) {
    return {
        type: ACTIVITY_DETAIL,
        data
    }
};

export function getActivityDetailSuccess(data) {
    return {
        type: ACTIVITY_DETAIL_SUCCESS,
        data
    }
};

export function getActivityDetailError(data) {
    return {
        type: ACTIVITY_DETAIL_ERROR,
        data
    }
};

export function GetActivityDetails(idActivity, idCommunity) {
    return dispatch => {
        dispatch(getActivityDetail());
        return fetch(API_URL + 'activities/activities/' + idActivity,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getActivityDetailSuccess(res));
                return res
            })
            .catch(error => {
                dispatch(getActivityDetailError(error));
            })
    }
}

//#endregion

//#region  Add Activity
export function addActivity(data) {
    return {
        type: ADD_ACTIVITY,
        data
    }
};

export function addActivitySuccess(data) {
    return {
        type: ADD_ACTIVITY_SUCCESS,
        data
    }
};

export function addActivityError(data) {
    return {
        type: ADD_ACTIVITY_ERROR,
        data
    }
};

export function AddActivity(data, idCommunity) {
    return dispatch => {
        dispatch(addActivity());

        fetch(API_URL + 'activities/activities',
            {
                body: JSON.stringify(data),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity
                }
            })
            .then(res => res.json())
            .then(res => {
                const message = `The activity has been added successfully`


                dispatch(addActivitySuccess(res));

                sweetAlert('success', message, 'alert_ActivitySuccess');

                return res;
            })
            .catch(error => {
                const message = `An error occurred when adding the activity`

                dispatch(addActivityError(error));

                sweetAlert('error', message, 'alert_ActivityError');
            })
    }
};
//#endregion

//#region  Update Activity
export function updActivity(data) {
    return {
        type: UPDATE_ACTIVITY,
        data
    }
};

export function updActivitySuccess(data) {
    return {
        type: UPDATE_ACTIVITY_SUCCESS,
        data
    }
};

export function updActivityError(data) {
    return {
        type: UPDATE_ACTIVITY_ERROR,
        data
    }
};

export function UpdActivity(idActivity, data, idCommunity) {


    return dispatch => {
        dispatch(updActivity());

        fetch(API_URL + 'activities/activities/' + idActivity,
            {
                body: JSON.stringify(data),
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity,
                }
            })
            .then(res => {
                const message = `The activity has been updated successfully`

                dispatch(updActivitySuccess(data));

                sweetAlert('success', message, 'alert_Update_Success');
                return res;
            })
            .catch(error => {
                const message = `An error has occurred while Updating the activity`

                dispatch(updActivityError(error));

                sweetAlert('error', message, 'alert_Update_Error');

            })
    }
};
//#endregion

//#region  DELETE Activity
export function delActivity(data) {
    return {
        type: DELETE_ACTIVITY,
        data
    }
};

export function delActivitySuccess(data) {
    return {
        type: DELETE_ACTIVITY_SUCCESS,
        data
    }
};

export function delActivityError(data) {
    return {
        type: DELETE_ACTIVITY_ERROR,
        data
    }
};

export function DelActivity(activity, idCommunity) {
    return dispatch => {
        dispatch(delActivity());

        // dispatch(delActivitySuccess(activity._id));

        //DOES NOT EXIST END POINT TO DELETE ACTIVITY
        fetch(API_URL + 'activities/activities/' + activity._id,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity ? idCommunity : 'fca32fc3-6389-4333-bc89-f05564ef8611',
                }
            })
            .then(res => {
                dispatch(delActivitySuccess(activity));

                const message = 'The activity has been deleted successfully';

                sweetAlert('success', message, 'alert_Delete_Success');
                return res;
            })
            .catch(error => {
                dispatch(delActivityError(error));

            })
    }
};

//#endregion


//#region  DELETE Activities
export function delActivities(data) {
    return {
        type: DELETE_ACTIVITIES,
        data
    }
};

export function delActivitiesSuccess(data) {
    return {
        type: DELETE_ACTIVITIES_SUCCESS,
        data
    }
};

export function delAllActivitiesSuccess(data) {
    return {
        type: DELETE_ALL_ACTIVITIES_SUCCESS,
        data
    }
};

export function delActivitiesError(data) {
    return {
        type: DELETE_ACTIVITIES_ERROR,
        data
    }
};

export function DelActivities(activities) {
    return dispatch => {
        dispatch(delActivities());


        //DOES NOT EXIST END POINT TO DELETE ACTIVITY
        fetch(API_URL + 'activities/activities',
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'activities': activities
                }
            })
            .then(res => {
                dispatch(delActivitiesSuccess(activities));

                const message = 'The activities has been deleted successfully';

                sweetAlert('success', message, 'alert_Delete_Success');
                return res;
            })
            .catch(error => {
                dispatch(delActivitiesError(error));
            })
    }
};

export function DelAllActivities(idCommunity, filters, search) {
    return dispatch => {
        dispatch(delActivities());

        const headers = getHeaders(filters, idCommunity, search);

        fetch(API_URL + 'activities/community',
            {
                method: 'DELETE',
                headers: headers
            })
            .then(res => {
                dispatch(delAllActivitiesSuccess([]));

                const message = 'The activities has been deleted successfully';

                sweetAlert('success', message, 'alert_Delete_Success');
                return res;
            })
            .catch(error => {
                dispatch(delActivitiesError(error));

            })
    }
};
//#endregion


export function delRecurrenceActivity(data) {
    return {
        type: DELETE_RECURRENCE_ACTIVITY,
        data
    }
};

export function delRecurrenceActivitySuccess(data) {
    return {
        type: DELETE_RECURRENCE_ACTIVITY_SUCCESS,
        data
    }
};

export function delRecurrenceActivityError(data) {
    return {
        type: DELETE_RECURRENCE_ACTIVITY_ERROR,
        data
    }
};

export function DeleteRecurrenceActivity(activity, idCommunity) {
    return dispatch => {
        dispatch(delRecurrenceActivity());

        fetch(API_URL + 'activities/activityRecurrence/' + activity._id,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity ? idCommunity : 'fca32fc3-6389-4333-bc89-f05564ef8611',
                }
            })
            .then(res => {
                dispatch(delRecurrenceActivitySuccess(activity));

                const message = 'The activities have been deleted successfully';

                sweetAlert('success', message, 'alert_Delete_Success');
                return res;
            })
            .catch(error => {
                dispatch(delRecurrenceActivityError(error));

            })
    }
};

//#region ADD Image  Used in both Detail and Thumbnail Image
export function addDetailsImage(data) {
    return {
        type: ADD_DETAILS_IMAGE,
        data
    }
};

export function addDetailsImageSuccess(data) {
    return {
        type: ADD_DETAILS_IMAGE_SUCCESS,
        data
    }
};

export function addDetailsImageError(data) {
    return {
        type: ADD_DETAILS_IMAGE_ERROR,
        data
    }
};

export function AddDetailsImage(data, idCommunity) {
    return dispatch => {
        dispatch(addDetailsImage());

        return fetch(API_URL_V2 + 'activities/addImage',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity
                }
            })
            .then(res => { const resJson = res.json(); return resJson; })
            .then(res => {
                dispatch(addDetailsImageSuccess(res));

                return res;
            })
            .catch(error => {
                dispatch(addDetailsImageError(error));

            })
    }
};

//#endregion

export function getImages(data) {
    return {
        type: GET_ACTIVITIES_IMAGES,
        data
    }
};

export function getImagesSuccess(data) {
    return {
        type: GET_ACTIVITIES_IMAGES_SUCCESS,
        data
    }
};

export function getImagesError(data) {
    return {
        type: GET_ACTIVITIES_IMAGES_ERROR,
        data
    }
};

export function GetActivitiesImages(idCommunity) {
    return dispatch => {
        dispatch(getImages());

        fetch(API_URL + 'activities/images/' + idCommunity,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getImagesSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getImagesError(error));

            })
    }
};


export function GetCategorieObject(iconUrl, categoryColor, categoryId) {
    return async () => {
        try {
            let headers = {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'iconurl': iconUrl,
                'categorycolor': categoryColor,
            }

            if (categoryId && categoryId.length > 0) {
                headers = {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'iconurl': iconUrl,
                    'categorycolor': categoryColor,
                    'categoryid': categoryId,
                }

            }

            const res = await fetch(API_URL + 'activities/getCategoryIconObject',
                {
                    method: 'GET',
                    headers: headers
                });

            const json = (res) ? await res.json() : undefined;
            const data = (json.data) ? json.data : '';
            return data;
        }
        catch (err) {
            return { success: false }
        }
    }
}

export function GetMultipleCategorieObject(urlObjArray) {
    return async () => {
        try {
            let headers = {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'urlsarray': JSON.stringify(urlObjArray),
            }

            const res = await fetch(API_URL + 'activities/getMultipleCategoryIconObject',
                {
                    method: 'GET',
                    headers: headers
                });

            const json = (res) ? await res.json() : undefined;
            const data = (json.data) ? json.data : '';
            return data;
        }
        catch (err) {
            return { success: false }
        }
    }
}


//#region GET ACTIVITY
export function getTags(data) {
    return {
        type: ACTIVITY_TAGS,
        data
    }
};

export function getTagsSuccess(data, communityId, currentPage) {
    return {
        type: ACTIVITY_TAGS_SUCCESS,
        data,
    }
};

export function getTagsError(data) {
    return {
        type: ACTIVITY_TAGS_ERROR,
        data
    }
};

export function GetActivitiesTags(idCommunity, dateChanged, dateOption, startDate, endDate) {
    return dispatch => {
        dispatch(getTags());


        const headers = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'CommunityId': idCommunity,
        }

        if (dateOption) {
            headers.date_option = dateOption
        } else if (dateChanged && startDate && endDate) {
            headers.start_date = startDate
            headers.end_date = endDate
        }

        return fetch(API_URL + `activities/tags`,
            {
                method: 'GET',
                headers: headers
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getTagsSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getTagsError(error));
            })
    }
};


export async function ExportActivities(communityId, communityName) {
    try {
        const newCommunityName = communityName ? communityName.split(' ').filter(a => a.length > 0).map(a => a.trim()).join('_') : '';

        const headers = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'CommunityId': communityId,
        }

        const fetchRes = await fetch(API_URL + `activities/getAllActivitiesCLFormatted`,
            {
                method: 'GET',
                headers: headers
            })

        let dataObj = undefined;
        let data = [];
        let specialActivities = [];
        let headerArray = []
        let specialActivitiesHeadersArray = [];
        let pictureInfoCLHeadersArray = [];
        let activitiesPictureInfoCLFormatted = [];

        if (fetchRes && fetchRes.status === 200) {
            dataObj = await fetchRes.json();
        }

        if (dataObj) {
            data = await dataObj.data;
            specialActivities = await dataObj.specialActivities;
            headerArray = await dataObj.headers;
            specialActivitiesHeadersArray = await dataObj.specialHeaders;
            pictureInfoCLHeadersArray = await dataObj.pictureInfoCLHeaders;
            activitiesPictureInfoCLFormatted = await dataObj.activitiesPictureInfoCLFormatted;
        }

        if (data && data.length > 0 && headerArray && headerArray.length > 0) {
            const workSheet = XLSX.utils.json_to_sheet(data, { header: headerArray });
            const workBook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workBook, workSheet, "events");

            const fileName = `Events_Data_${newCommunityName}_${communityId}.csv`

            XLSX.writeFile(workBook, fileName);
        }

        if (specialActivities && specialActivities.length > 0 && specialActivitiesHeadersArray && specialActivitiesHeadersArray.length > 0) {
            const workSheet = XLSX.utils.json_to_sheet(specialActivities, { header: specialActivitiesHeadersArray });
            const workBook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workBook, workSheet, "specialEvents");

            const fileName = `Events_Recurrence_${newCommunityName}_${communityId}.csv`

            XLSX.writeFile(workBook, fileName);
        }

        if (activitiesPictureInfoCLFormatted && activitiesPictureInfoCLFormatted.length && pictureInfoCLHeadersArray && pictureInfoCLHeadersArray.length) {
            const workSheet = XLSX.utils.json_to_sheet(activitiesPictureInfoCLFormatted, { header: pictureInfoCLHeadersArray });
            const workBook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workBook, workSheet, "pictureUrls");

            const fileName = `Events_Pictures_${newCommunityName}_${communityId}.csv`

            XLSX.writeFile(workBook, fileName);
        }
    } catch (err) {
        return undefined
    }
}